module.exports = {
	"fb": false,
	"go": false,
	"login": false
};


//////////////////
// WEBPACK FOOTER
// ./src/config/builder/appsettings.json
// module id = 1081
// module chunks = 0